import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function CareerInnerBanner() {

  const [CareerInnerBanner, setCareerInnerBanner] = useState([]);

  useEffect(() => {
    const fetchCareerInnerBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/inner-banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCareerInnerBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCareerInnerBanner();
  }, []);

  return (
    <div
      className="common-banner-sec common-flex-center career-inner-banner"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + CareerInnerBanner.banner_image
          })`,
      }}
    >
      <div className="overlay"></div>
      <Container fluid>
        <Row className="common-flex-center">
          <Col md={8}>
            <div className=" ">
              <h1 className="common-head whiteColor">
                {CareerInnerBanner.banner_title}
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CareerInnerBanner;
